import { NOTIFICATIONS_FETCH, NOTIFICATIONS_SET } from "./notificationActions";

const defaultState = { list: [], fetching: false };

export const notifications = (state = defaultState, action) => {
  switch (action.type) {
    case NOTIFICATIONS_FETCH:
      return {
        ...state,
        fetching: true,
      };
    case NOTIFICATIONS_SET:
      return {
        ...state,
        list: action.value,
        fetching: false,
      };
    default:
      return state;
  }
};
